export const SomethingWentWrongError = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-label">⚠️ Error</div>
        <h1>Something went wrong</h1>
        <p>Sorry!, an unexpected error occurred. Our team has been notified.</p>
        <button className='go-backmenu' onClick={() => window.location.reload()}>↻ Reload page</button>
      </div>
    </div>
  );
};
